import {useEffect, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";

let port:any = null;

export const AdminsStaffAssignCardModal = (props: { active: boolean, closeHandler: any, staffId: string,onDone:any }) => {
    const [status, setStatus] = useState('select' as 'select' | 'opening' | 'write' | 'reading');
    const getCard = async () => {
        setStatus('select');
        try{
            // @ts-ignore
            port = await navigator.serial.requestPort();
        } catch(e){
            ShowSnackbar(
                'لطفا یک پورت را انتخاب کنید.',
                'باشه',
                5000,
            );
            props.closeHandler();
            return;
        }
        if(port === null){
            ShowSnackbar(
                'لطفا یک پورت را انتخاب کنید.',
                'باشه',
                5000,
            );
            props.closeHandler();
            return;
        }
        setStatus('opening');
        try {
            await port.open({baudRate: 9600});
        } catch (e) {
            ShowSnackbar(
                'لطفا یک پورت را انتخاب کنید.',
                'باشه',
                5000,
            );
            props.closeHandler();
            return;
        }
        setStatus('write');
        const writer = port.writable.getWriter();
        await writer.write(new TextEncoder().encode('ar3'));
        writer.releaseLock();
        let reader = port.readable.getReader();
        let {value, done} = await reader.read();
        let x = new TextDecoder().decode(value).trim();
        reader.releaseLock();
        if (x !== 'artison') {
            props.closeHandler();
            port.close();
            ShowSnackbar(
                'دستگاه انتخاب شده، کارتخوان آرتیسان نیست!',
                'باشه',
                5000,
            );
            return;
        }

        setStatus('reading');
        let reader2 = port.readable.getReader();
        let a = await reader2.read();
        let x2 = new TextDecoder().decode(a.value).trim();
        console.log(x2);
        reader2.releaseLock();

        await port.close();

        port = null;

        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/attend/assign-card',
            {
                staff: props.staffId,
                rfid: x2,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'کارت جدید ثبت شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void (0));
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setStatus('select');
            setTimeout(getCard, 500);
        } else {
            document.body.classList.remove('body-no-scroll');
            if(port !== null)
                port.close();
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>اختصاص کارت</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="fingerprint-scanner">
                        <div>
                            <em style={{backgroundImage: 'url(https://techara-images.ir/ar3/v/devices/rfid/small.jpg)'}}/>
                            {status === "reading" ? <i/> : null}
                        </div>
                        {(()=>{
                            const x = status;
                            switch (x) {
                                case "select":
                                    return <b>پورت را انتخاب کنید.</b>;
                                case "opening":
                                    return <b>در حال تماس با دستگاه...</b>;
                                case "write":
                                    return <b>در حال شناسایی...</b>;
                                case "reading":
                                    return <b>لطفا کارت را با دستگاه اسکن کنید.</b>;
                                default:
                                    return "";
                            }
                        })()}
                    </div>
                </div>
            </div>
        </>
    );
};